// extracted by mini-css-extract-plugin
module.exports = {"Intro":"Intro_Intro__2-4JS"};